import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Tooltip } from 'react-bootstrap';
import $ from 'jquery';

/* Function */
import ObjGeneral from '../function/';
import Constants from '../function/constants.js';
/* Local store */
import { localStoreFN } from '../../store/localStorage';

/* Actions */
import * as driverBehaviorActions from '../../actions/driver_behavior/index';
import * as accountDriverActions from '../../actions/account_driver/index';
import * as dashboardActions from '../../actions/dashboard/index.js';
import * as headerActions from '../../actions/header/index.js';

/* Components */
import Header from '../../components/driver_behavior/header';
import Main from '../../components/driver_behavior/main';
import Buttons from '../../components/driver_behavior/buttons';
import Detail from '../../components/driver_behavior/detail';
import ButtonsTop from '../../components/driver_behavior/buttonsTop';
import TravelModal from '../../components/driver_behavior/travelModal';
import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import Expired from '../expired/index';
import tourConfig from '../../components/common/tour/config';
import tourSteps from '../../components/driver_behavior/tourSteps';

class DriverBehavior extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTravelModal: false,
      showTravelModalMap: false,
      driver: 0,
      firstOpen: true,
      isTourOpen: null
    };
  }

  async componentDidMount() {
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('behaviour');
    if (permit) {
      if (this.props.setting) {
        const obj = JSON.parse(this.props.setting.value);
        if (obj.generalSetting.views.includes('behaviour')) {
          const dateStart = this.props.filters.date.fechaStartFinal || null;
          const dateEnd = this.props.filters.date.fechaEndFinal || null;
          const tags = this.props.filters.tags;
          const driver = this.props.filters.driver ? this.props.filters.driver.id : null;
          this.state.driver = driver;

          await this.props.accountDriverActions.fetchAccountDriverApi({
            dateStart,
            dateEnd,
            tags,
            seeFilter: true
          });
          await this.props.actions.fetchDriverBehaviorApi({
            dateStart,
            dateEnd,
            tags,
            driver: driver
          });
          this.props.headerActions.setRepeatTourAction(this.openTour);
        } else {
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      this.props.history.push('/dashboard/authorization');
    }
    document.addEventListener('mousedown', this.handleClickOutsideModal, false);
  }

  openTour = () => {
    this.setState({
      isTourOpen: true
    });
  };


  closeTour = async () => {
    const viewedTours = localStoreFN().getItem('viewedTours');
    const tourComplete = viewedTours ? JSON.parse(viewedTours)[Constants.toursKeys.driverBehavior] : false;
    if(tourComplete==false) {
      await this.props.dashboardActions.setTourViewed({tourName:Constants.toursKeys.driverBehavior});
    }

    this.setState({
      isTourOpen: false
    });
  };

  componentDidUpdate = (prevProps, prevState) => {
    if(!this.props.loading && !this.props.loadingFilter  && !this.props.accountDriverLoading
        && this.props.status === 200 && this.props.statusTags === 200
        && this.props.accountDriverStatus === 200
        && this.state.firstOpen==true) {
      const viewedTours = localStoreFN().getItem('viewedTours');
      const tourComplete = viewedTours ? JSON.parse(viewedTours)[Constants.toursKeys.driverBehavior] : false;
      // tour load when the sight just enters
      this.state.firstOpen = false;
      if(tourComplete==false) {
        this.state.isTourOpen = true;
        tourConfig.openTourJsCall(tourSteps, this.closeTour, this.props.language, ".main-container.scroll");
      }
      else {
        this.state.isTourOpen = false;
      }
    }

    // tour loading when later called
    if(prevState.isTourOpen==false && this.state.isTourOpen==true) {
      tourConfig.openTourJsCall(tourSteps, this.closeTour, this.props.language, ".main-container.scroll");
    }
  };

  componentWillUnmount() {
    this.props.actions.resetDriverBehavior();
    this.props.headerActions.resetHeader();
    document.removeEventListener('mousedown', this.handleClickOutsideModal, false);
  }

  handleDownloadExcelSummary = async obj => {
    await this.props.actions.downloadSummaryReport({
      dateStart: this.props.filters.date.fechaStartFinal,
      dateEnd: this.props.filters.date.fechaEndFinal,
      driver: this.props.filters.driver ? this.props.filters.driver.id : null,
      tags: this.props.filters.tags,
    });
  };

  handleDownloadExcelNoProcess = async obj => {
    await this.props.actions.downloadNoProcessReport({
      dateStart: this.props.filters.date.fechaStartFinal,
      dateEnd: this.props.filters.date.fechaEndFinal,
      driver: this.props.filters.driver ? this.props.filters.driver.id : null,
      tags: this.props.filters.tags,
    });
  };

  handleSubmit = async obj => {
    const format = this.props.language.account.date.format;

    let driver = this.state.driver;
    let driverText = this.props.filters.driver;
    if (obj.id == 'driver') {
      driver = Number.isInteger(obj.value) ? obj.value : 0;
      if (Number.isInteger(obj.value)) {
        driverText = this.props.accountDriverDatos.find(o => o.id === obj.value);
      } else {
        driverText = null;
      }
      this.setState({ driver: driver });
    }

    /* TAGS */
    const tags = (obj.multipleTagsInputIsMultiple) ? ObjGeneral.getTags(obj) : this.props.filters.tags;
    /* DATE */
    const date = ObjGeneral.getDate(obj, format);

    this.props.actions.setFilterDriverBehavior({
      tags: tags,
      date: date,
      driver: driverText
    });
    await this.props.accountDriverActions.fetchAccountDriverApi({
      seeFilter: true,
      tags: tags,
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal
    });

    await this.props.actions.fetchDriverBehaviorApi({
      tags: tags,
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      driver: driver
    });
  };

  colorSeverityItem = severety => {
    // condition to define the color as defined in the api
    if (severety == null) {
      return 'gris';
    } else if (severety.toUpperCase() === 'HIGHRISK') {
      return 'red';
    } else if (severety.toUpperCase() === 'OUTOFRISK') {
      return 'green';
    }
    return 'yellow';
  };

  handleTravelClick = async id => {
    $('.container-modal-right').css('width',($('.operation-indicators').width()+60)+"px");
    this.setState({
      showTravelModal: true
    });
    setTimeout(()=>{
      this.setState({
        showTravelModalMap: true
      });
    }, 500);
    await this.props.actions.fetchMapApi(id);
  };

  handleOnHideTravelDetailModal = e => {
    e.stopPropagation();
    this.setState({showTravelModal: false});
    setTimeout(()=>{
      this.setState({
        showTravelModalMap: false
      });
    }, 200);
    $('.travels-table .travel-row.active').removeClass('active');
  };

  handleClickOutsideModal = e => {
    var target = $(e.target);
    if (
      !target.closest('.task-modal.container-modal-right').length && //Inside Modal
      e.target.nodeName != 'HTML' && //Page general scroll
      !target.closest('.travels-table').length &&
      this.state.showTravelModal
    ) {
      //Task table row
      this.handleOnHideTravelDetailModal(e);
    }
  };

  handleModalSlide = e => {
    var toHide = $('.slide-panel.show');
    var toShow = $('.slide-panel.hide');

    toHide.addClass('hide');
    toHide.removeClass('show');

    toShow.addClass('show');
    toShow.removeClass('hide');
  };

  render() {
    // condition done to see if the setting was done
    if (this.props.setting) {
      const lang = localStoreFN().getItem('lang');
      const obj = JSON.parse(this.props.setting.value);
      const setting = ObjGeneral.getSetting({
        setting: obj.driverBehavior,
        filter: this.props.filter,
        general: obj.generalSetting
      });
      const behaviorConfig = obj.behaviorConfig[lang];

      const header = (
        <Header
          handleSubmit={this.handleSubmit}
          language={this.props.language}
          filter={setting.filter}
          date={this.props.dateMax[2]}
          filters={this.props.filters}
          loadingFilter={this.props.loadingFilter}
          defaultRangeInDay={obj.behavior.defaultRangeInDay}
          drivers={this.props.accountDriverDatos}
        />
      );
      let container = '';
      // condition performed for loading state of the view
      if (this.props.loading
        || this.props.loadingFilter
        || this.props.accountDriverLoading) {
        container = <Loading language={this.props.language} />;
        // the 401 status of the application Expired token or unauthorized
      } else if (
        this.props.status === 401 ||
        this.props.statusTags === 401 ||
        this.props.accountDriverStatus === 401
      ) {
        container = <Expired history={this.props.history} />;
        // the status 200 of the application success
      } else if (
        this.props.status === 200 &&
        this.props.statusTags === 200 &&
        this.props.accountDriverStatus === 200
      ) {
        container = (
          <div className={
            "main-container scroll full-height " +
            "driver-behaviour-view " +
            "common-behaviour " +
            "common-dashboards " +
            "common-driver-container " +
            this.colorSeverityItem(this.props.datos.severity)
          }>
            <div className="full-height-container">
              <ButtonsTop
                language={this.props.language ? this.props.language : ''}
                filters={this.props.filters}
                handleSubmit={this.handleSubmit}
                driverName={this.props.datos.driverName}
              />
              <Main
                datos={this.props.datos}
                title={this.props.language}
                tooltip={this.props.language}
                graphColorRange={obj.graphColorRange.behaviorGrade}
                language={this.props.language}
              />
              <Buttons
                language={this.props.language ? this.props.language : ''}
                handleDownloadExcelSummary={this.handleDownloadExcelSummary}
                handleDownloadExcelNoProcess={this.handleDownloadExcelNoProcess}
              />
              <Detail
                datos={this.props.datos}
                graphColorRange={obj.graphColorRange.behaviorGrade}
                language={this.props.language}
                filter={setting.filter}
                behaviorConfig={behaviorConfig}
                handleTravelClick={this.handleTravelClick}
              />
            </div>
            <TravelModal
              language={this.props.language}
              handleModal={this.handleOnHideTravelDetailModal}
              showModal={this.state.showTravelModal}
              showMap={this.state.showTravelModalMap}
              loading={this.props.loadingMap}
              data={this.props.datosMap}
              status={this.props.statusMap}
              handleModalSlide={this.handleModalSlide}
              behaviorConfig={behaviorConfig}
              graphColorRange={obj.graphColorRange.behaviorGrade}
            />
            <Tooltip placement="top" id="pageTooltip" />
          </div>
        );
      } else if (
        this.props.status === 500 ||
        this.props.statusTags === 500 ||
        this.props.accountDriverStatus === 500
      ) {
        container = <Message message={this.props.language.error.apiError500} />;
      } else {
        container = <Message message={this.props.language.error.apiError} />;
      }
      return (
        <section className="main">
          {header}
          {container}
        </section>
      );
    }

    return (
      <section className="main">
        <Message message="NO Setting" />
      </section>
    );
  }
}

const mapStateToProps = state => ({
  filter: state.reducer.tags.filter,
  statusTags: state.reducer.tags.status,
  loadingFilter: state.reducer.tags.loading,

  accountDriverDatos: state.reducer.accountDriver.datos,
  accountDriverStatus: state.reducer.accountDriver.status,
  accountDriverLoading: state.reducer.accountDriver.loading,

  language: state.reducer.dashboard.language,
  dateMax: state.reducer.dashboard.dateMax,
  setting: state.reducer.dashboard.setting,

  datos: state.reducer.driverBehavior.datos,
  loading: state.reducer.driverBehavior.loading,
  status: state.reducer.driverBehavior.status,
  filters: state.reducer.driverBehavior.filters,

  datosMap: state.reducer.driverBehavior.datosMap,
  loadingMap: state.reducer.driverBehavior.loadingMap,
  statusMap: state.reducer.driverBehavior.statusMap,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(driverBehaviorActions, dispatch),
  accountDriverActions: bindActionCreators(accountDriverActions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch),
  headerActions: bindActionCreators(headerActions, dispatch)
});

DriverBehavior.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverBehavior);



// WEBPACK FOOTER //
// ./source/client/containers/driver_behavior/index.jsx